// Причину отказа API кладёт в error, реже — в message фреймворка.
// У сетевого сбоя нет ни того, ни другого, поэтому нужен запасной текст:
// без него человек видел пустой экран и считал, что записей нет.
export const getRequestErrorMessage = (
    error,
    fallback = "Не удалось загрузить данные. Проверьте связь и повторите."
) => error?.response?.data?.error ?? error?.response?.data?.message ?? fallback;
